// Topic tag -> on-brand hero image. Projects map to their primary topic's image.
const B = "https://static.prod-images.emergentagent.com/jobs/c62baeb7-ffa0-4479-a158-5c9510376f42/images/";

const IMG = {
  agents: B + "c2332557d204db065b396435fedf5b1518ce5d0ff0a11a6fb5bc83bb6ef60f58.jpeg",
  voice: B + "e766a1e3be4111d068d9a596ecf40c380551d45caea904e6ef8ed7fef9375cf7.jpeg",
  payments: B + "c3a68c1f7491659bbfd85aae727e4ac6754c4c76c797d05bece7e5c311da8b1a.jpeg",
  wallet: B + "48793ec03aab1db4a5680f62f2337bf7b004c423c1e9070fda4f05385e9b6779.jpeg",
  investing: B + "a9df3d524c26c306fc1984055c9a69f475dcb9b419a9a74a1a91e2ebaa1f6713.jpeg",
  security: B + "4153bd8cafd1edbb9618f7f9618003b88a8299dc32ccac48b5ff920739b94a4b.jpeg",
  privacy: B + "ab3a44d6d9b395bfa38bfe470e01d6904123acac4c18c95d52eae0618fb9409b.jpeg",
  education: B + "32e9f576c1d52de0aacc9b56fd0b352548552da93b5109377fbb6cfb606d1ce8.jpeg",
  health: B + "64ffc380ead3c4eb0a76e969cdd39cff20e0571e475434a081f880c5aad337b8.jpeg",
  accessibility: B + "0fe8457cdf48b414f5cade245b8c4718b0c84684afcbf3249fe1a2bc02a50711.jpeg",
  travel: B + "2d0ad2b9b1754be29766c6728116b2d814b1a2dbc0d2df189e7e30f80614ac7c.jpeg",
  commerce: B + "b8821c6312040ba36690d78bf819f4da4dde142dbe92796b92d8b0828947a08c.jpeg",
  social: B + "c1aa40f5e682578f4f05592d1204f5240069cf889e9e7b7e362da334c8c2a60a.jpeg",
  creators: B + "6f26e0c8befd91f7ec63989aba0b7855625b85e0109725f2bccdde23000396e7.jpeg",
  gaming: B + "65b80c952a4a3d4d08b4c47773e5430de37c90cbeb1c1b15b282f9b94767585d.jpeg",
  enterprise: B + "94e259f1065dfdb17ffd7e2b9deb58f8609e4014a7818f9847d1e69aff22c08f.jpeg",
  sustainability: B + "ade8a7c0ff4762fec37313d0ae5ccc8ba62fed7f2076041304bb937bd0a27586.jpeg",
  productivity: B + "aaf5eeca6931c899cd6d7078ba9133fd90c15ff658d9b8f1d260058e1c096d9b.jpeg",
};

// every topic tag -> one of the 18 generated images
const TAG_TO_KEY = {
  "#Agents": "agents", "#AI": "agents",
  "#Voice": "voice",
  "#Payments": "payments", "#Lending": "payments", "#Insurance": "payments",
  "#Wallet": "wallet", "#DeFi": "wallet", "#Web3": "wallet",
  "#Investing": "investing", "#Finance": "investing", "#Careers": "investing",
  "#Security": "security",
  "#Privacy": "privacy", "#Identity": "privacy",
  "#Education": "education", "#Research": "education",
  "#Health": "health", "#Pets": "health", "#Kids": "health", "#Seniors": "health",
  "#Accessibility": "accessibility", "#Translation": "accessibility",
  "#Travel": "travel",
  "#Commerce": "commerce",
  "#Social": "social",
  "#Creators": "creators",
  "#Gaming": "gaming",
  "#Enterprise": "enterprise", "#DevTools": "enterprise", "#IoT": "enterprise",
  "#Sustainability": "sustainability",
  "#Productivity": "productivity",
};

const TRACK_TAGS = ["#AI", "#Web3"];
const ECOSYSTEM = ["#U-Bot", "#U-Topia", "#Avalanche"];

export function topicImage(u_tags = []) {
  const candidates = (u_tags || [])
    .filter((t) => !TRACK_TAGS.includes(t) && !ECOSYSTEM.includes(t) && TAG_TO_KEY[t])
    .map((t) => TAG_TO_KEY[t]);
  // prefer a specific topic over the generic "agents" (which #AI/#Agents map to) for visual diversity
  const specific = candidates.find((k) => k !== "agents");
  const key = specific || candidates[0] || (u_tags.includes("#Web3") ? "wallet" : "agents");
  return IMG[key];
}
